import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import Button from "../common/button/button";
import DateFormat from "../common/dateFormat/DateFormat";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Select from "../common/form/select";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import {
  reprocessarMensalidades,
  setFiltro,
  getMensalidades,
} from "./mensalidadeActions";
import { getLista as getListaSindicatos } from "../sindicato/sindicatoActions";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { Loading } from "../common/loading/loading";

class Mensalidade extends Component {
  componentWillMount() {
    this.props.getListaSindicatos();
  }

  render() {
    return (
      <Content>
        <ContentCard>
          <ContentCardHeader>
            {this.props.resultadoEnvio ? (
              <h6
                style={{
                  color: this.props.listaRetorno.length ? "#F22" : "#37a45d",
                }}
              >
                {this.props.resultadoEnvio}
              </h6>
            ) : (
              <h6
                style={{
                  color: this.props.lista.length ? "#37a45d" : "#3c86f6",
                }}
              >
                {this.props.lista.length
                  ? 'Confira as mensalidades e clique em "Enviar para a FETAG" se forem as pendentes'
                  : "Selecione o sindicato e a data em que deseja reenviar as mensalidades"}
              </h6>
            )}

            <Row>
              <Select
                name="id_sindicato_acesso"
                options={this.props.listaSindicatos}
                label="Sindicato"
                cols="12 12 4 4"
                placeholder="Selecione o Sindicato"
                value={this.props.filtro.id_sindicato_acesso}
                isClearable={false}
                isSearchable={false}
                onChange={(value) => {
                  this.props.setFiltro({
                    ...this.props.filtro,
                    id_sindicato_acesso: value,
                  });
                }}
              />

              <Grid cols="12 12 4 4">
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                  <DatePicker
                    variant="inline" // mostra sempre aberto
                    openTo="date"
                    views={["year", "month", "date"]}
                    label="Data"
                    autoOk
                    format="dd/MM/yyyy" // 👈 força formato dd/MM/aaaa
                    value={this.props.filtro.data}
                    maxDate={new Date()} // <-- limita até hoje
                    onChange={(value) => {
                      this.props.setFiltro({
                        ...this.props.filtro,
                        data: value,
                      });
                    }}
                    style={{ marginTop: 15 }} // 👈 reduz tudo
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid
                cols="12 12 4 4"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {this.props.lista.length && !this.props.resultadoEnvio ? (
                  <Button
                    text="Enviar para a FETAG"
                    title="Enviar para a FETAG"
                    type={"success"}
                    icon={"fa fa-paper-plane"}
                    event={() => {
                      this.props.reprocessarMensalidades();
                    }}
                  />
                ) : (
                  <Button
                    text="Buscar Mensalidades"
                    title="Buscar Mensalidades"
                    type={"primary"}
                    icon={"fa fa-search"}
                    event={() => {
                      this.props.getMensalidades();
                    }}
                  />
                )}
              </Grid>
            </Row>
          </ContentCardHeader>
          {this.props.aguardando ? (
            <Loading />
          ) : (
            <ContentCardBody>
              {this.props.lista.length ? (
                <Table responsive>
                  <THead>
                    <Tr>
                      <Th>Nome Sócio</Th>
                      <Th>Nº Recibo</Th>
                      <Th>Data</Th>
                      <Th>Valor Mensal</Th>
                      <Th>Valor Total</Th>
                    </Tr>
                  </THead>
                  <TBody>
                    {this.props.lista.map((item, i) => (
                      <Tr key={i}>
                        <Td paddingLeft={20}>{item.nome}</Td>
                        <Td minWidth={80} noWrap>
                          {item.nRecibo}
                        </Td>
                        <Td minWidth={100} noWrap>
                          {item.data}
                        </Td>
                        <Td noWrap minWidth={80}>
                          {"R$ " + adicionarPontosMilhar(item.valorMes)}
                        </Td>
                        <Td noWrap minWidth={80}>
                          {"R$ " + adicionarPontosMilhar(item.total)}
                        </Td>
                      </Tr>
                    ))}
                  </TBody>
                </Table>
              ) : null}

              {this.props.listaRetorno.length ? (
                <Table responsive>
                  <THead>
                    <Tr>
                      <Th>Tipo de Erro</Th>
                      <Th>Descrição do Erro</Th>
                      <Th>Ano</Th>
                      <Th>Mês</Th>
                      <Th>Data</Th>
                      <Th>Nº Recibo</Th>
                      <Th>Valor Mês</Th>
                      <Th>Valor Total</Th>
                    </Tr>
                  </THead>
                  <TBody>
                    {this.props.listaRetorno.map((item, i) => (
                      <Tr key={i}>
                        <Td noWrap minWidth={80}>
                          {item.tipo_erro}
                        </Td>
                        <Td minWidth={80} noWrap>
                          {item.descricao_erro}
                        </Td>
                        <Td minWidth={80} noWrap>
                          {item.ano}
                        </Td>
                        <Td minWidth={80} noWrap>
                          {item.mes}
                        </Td>
                        <Td minWidth={80} noWrap>
                          {item.data}
                        </Td>
                        <Td minWidth={80} noWrap>
                          {item.nRecibo}
                        </Td>
                        <Td minWidth={80} noWrap>
                          {"R$ " + adicionarPontosMilhar(item.valorMes)}
                        </Td>
                        <Td minWidth={80} noWrap>
                          {"R$ " + adicionarPontosMilhar(item.total)}
                        </Td>
                      </Tr>
                    ))}
                  </TBody>
                </Table>
              ) : null}
            </ContentCardBody>
          )}
        </ContentCard>
      </Content>
    );
  }
}

const mapStateToProps = (state) => ({
  sessao: state.auth.usuario,
  modoTela: state.mensalidade.modoTela,
  aguardando: state.mensalidade.aguardando,
  lista: state.mensalidade.lista,
  listaRetorno: state.mensalidade.listaRetorno,
  resultadoEnvio: state.mensalidade.resultadoEnvio,
  filtro: state.mensalidade.filtro,
  listaSindicatos: (state.sindicato.lista || []).map((item) => ({
    id: item.id,
    valor: item.nome,
  })),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { reprocessarMensalidades, setFiltro, getListaSindicatos, getMensalidades },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Mensalidade);
